import {layoutReducer} from 'components/layout/layoutModule'
import pageReducer from 'components/page/pageModule'


const initialState = {
}

export default function reducer(state = initialState, action) {
  let nextState = layoutReducer(state, action)
  nextState = pageReducer(nextState, action)
  return nextState
}



// WEBPACK FOOTER //
// ./reducers/commonReducer.js